export default {
  NUM_0: 49,
  NUM_1: 50,
  NUM_2: 51,
  NUM_3: 52,
  NUM_4: 53,
  NUM_5: 54,
  NUM_6: 55,
  NUM_7: 56,
  NUM_8: 57,
  NUM_9: 58,
  DELETE: 8,
  ENTER: 13,
  LEFT: 37,
  RIGHT: 39,
  UP: 38,
  DOWN: 40,
  SPACE: 32,
  SHIFT: 16,
  COMMAND: 91,
  ALT: 18,
  CONTROL: 17,
  ESC: 27,
};
